import PropTypes from 'prop-types';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import AlertDialog from '../core/AlertDialog';

const CannotDeleteConfigurationDialog = ({ show, reasons = [], onClose }) => (
  <AlertDialog
    show={show}
    icon={
      <div className="bg-yellow-100 p-2 rounded-full">
        <ExclamationCircleIcon className="w-6 h-6 text-yellow-600" />
      </div>
    }
    title="Cannot delete configuration"
    onClose={onClose}
    actions={
      <button onClick={onClose} className="btn btn-sm bg-blue-500 hover:bg-blue-600 text-white border-none">
        OK
      </button>
    }
  >
    <p>This configuration is used in other modules and cannot be deleted.</p>
    {reasons.length > 0 && (
      <ul className="mt-3 list-disc pl-5 space-y-1">
        {reasons.map(reason => (
          <li key={reason}>{reason}</li>
        ))}
      </ul>
    )}
  </AlertDialog>
);

CannotDeleteConfigurationDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  reasons: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func.isRequired,
};

export default CannotDeleteConfigurationDialog;
